// Third-party
import React from 'react';

// Components
import { Cell } from './Cell';

// Types
import ProposalTableRowData from '@/types/proposal-table-row-data';
import ProposalTableCellData from '@/types/proposal-table-cell-data';
import Locale from '@/types/locale';

// Utils
import { LOCALE } from '@/utils/i18n';

interface HeaderProps {
  proposalTableRowData: ProposalTableRowData;
  locale?: Locale;
  tableId?: string;
  // Temporary prop to handle accessibility permission
  hasAccessibilityPermission?: boolean;
}

export const Header = ({ proposalTableRowData, locale, tableId, hasAccessibilityPermission = false }: HeaderProps) => (
  <tr className={proposalTableRowData.className}>
    {proposalTableRowData.data.map((proposalTableCellData: ProposalTableCellData, cellIndex: number) => {
      const style = {
        backgroundColor: proposalTableCellData.backgroundColor,
      };

      const isBlankCell = proposalTableCellData.className === 'hidden';

      if (hasAccessibilityPermission && isBlankCell) {
        return (
          <td key={cellIndex} colSpan={proposalTableCellData.colSpan} className={proposalTableCellData.className} style={style}>
            &nbsp;
          </td>
        );
      }

      return (
        <th
          id={tableId ? `${tableId}-header-${cellIndex}` : undefined}
          key={cellIndex}
          colSpan={proposalTableCellData.colSpan}
          className={proposalTableCellData.className}
          style={style}
          scope={hasAccessibilityPermission ? 'col' : undefined}
        >
          <Cell proposalTableCellData={proposalTableCellData} locale={locale || LOCALE.EN_CA} />
        </th>
      );
    })}
  </tr>
);
